import { logTableCallBridgeMessage as logSharedTableCallBridgeMessage } from "@bezoned/desktop-bridge/table-call-debug-log.js";
import type { TableCallBridgeDebugMessage } from "@bezoned/desktop-bridge/table-call-debug-log.js";

export const logTableCallBridgeMessage = ({
  direction,
  room,
  message,
}: {
  direction: "outbound" | "inbound";
  room: string;
  message: TableCallBridgeDebugMessage;
}) => {
  logSharedTableCallBridgeMessage({
    direction,
    isDevelopment: import.meta.env.DEV,
    message,
    room,
    scope: "table-call-bridge-sync",
  });
};
